import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const savedLocale = typeof localStorage !== 'undefined'
  ? (localStorage.getItem('cyma_locale') || 'zh-CN')
  : 'zh-CN'

export default new Vuex.Store({
  state: {
    toastText: '',
    loadingVisible: false,
    locale: savedLocale
  },
  mutations: {
    increment(state) {
      state.count++
    },
    toast(state, text) {
      state.toastText = text
      setTimeout(() => {
        state.toastText = ''
      }, 2000)
    },
    loading(state, loadingVisible) {
      state.loadingVisible = loadingVisible
    },
    setLocale(state, locale) {
      state.locale = locale
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('cyma_locale', locale)
      }
      if (typeof document !== 'undefined') {
        document.documentElement.lang = locale === 'en-US' ? 'en' : 'zh-CN'
      }
    },
    requireLogin(state) {
      const host = process.env.NODE_ENV === 'development' ? 'wxtest.zhichou.com' : 'wx.zhichou.com'
      location.assign('http://' + host + '/#/me/login?rurl=' + encodeURIComponent(location.href))
    }
  }
})
